export const CHANNELS_LIST = '/channels'
export const CHANNEL_ZENDESK = '/channels/zendesk'
export const CHANNEL_SHOPIFY = '/channels/shopify'
export const CHANNEL_INSTAGRAM = '/channels/instagram'
export const CHANNEL_MESSENGER = '/channels/messenger'
export const CHANNEL_SETTINGS = '/channels/:slug'
